<template>
  <v-form
    ref="form"
    v-model="valid"
    @submit="validate"
    @submit.prevent
    novalidate
  >
    <p>If you feel like you are missing my newsletter, you can always re-subscribe.</p>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="9">
        <v-text-field
          color="black"
          label="Your email"
          type="email"
          v-model="form.email"
          :rules="rules.email"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" class="text-center">
        <v-btn
          color="primary"
          type="submit"
          depressed
          squared
          :disabled="!valid"
        >Unsubscribe</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import {
  VBtn,
  VCol,
  VForm,
  VRow,
  VTextField,
} from 'vuetify/lib'
import MailerService from '@/services/MailerService'
import {Validators} from '@/utils/validators'
// import {db} from '@/plugins/firebase'

export default {
  components: {
    VBtn,
    VCol,
    VForm,
    VRow,
    VTextField,
  },
  data: () => ({
    form: {
      email: ''
    },
    rules: {
      email: [
        value => Validators.required(value) || 'Email is required.',
        value => Validators.email(value),
      ]
    },
    valid: false,
  }),
  methods: {
    reset() {
      this.$refs.form.reset();
    },
    validate() {
      if (this.$refs.form.validate()) {
        MailerService.unsubscribe(this.form.email)
          .then(() => {
            this.reset();
            this.$emit('submitted');
          });
        // db.collection('subscriptions')
        //     .doc(this.form.email)
        //     .delete()
        //     .finally(() => {
        //       this.reset();
        //       this.$emit('submitted');
        //     });
      }
    }
  },
  mounted() {
    if (this.email) {
      this.form.email = this.email
    }
  },
  props: {
    email: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped>
p {
  text-align: left;
}
</style>
